(function() {
  const originalAlert = window.alert;
  window.alert = function(message) {
    try {
      const overlay = document.createElement('div');
      // Force true viewport overlay and centering regardless of page styles
      overlay.setAttribute('role', 'dialog');
      overlay.style.position = 'fixed';
      overlay.style.inset = '0';
      overlay.style.width = '100vw';
      overlay.style.height = '100vh';
      overlay.style.display = 'flex';
      overlay.style.alignItems = 'center';
      overlay.style.justifyContent = 'center';
      overlay.style.background = 'rgba(0,0,0,0.55)';
      overlay.style.zIndex = '2147483647';

      const modal = document.createElement('div');
      modal.style.background = 'linear-gradient(180deg, #10b981, #000000)';
      modal.style.color = 'white';
      modal.style.padding = '20px 24px';
      modal.style.borderRadius = '14px';
      modal.style.boxShadow = '0 20px 40px rgba(0,0,0,0.35)';
      modal.style.textAlign = 'center';
      modal.style.maxWidth = '420px';
      modal.style.width = '90%';

      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('width', '56');
      icon.setAttribute('height', '56');
      icon.setAttribute('aria-hidden', 'true');
      icon.style.margin = '4px auto 8px';
      icon.innerHTML = '<path fill="currentColor" d="M12 2c.7 0 1.34.37 1.7.98l8.06 13.73c.73 1.24-.17 2.79-1.7 2.79H3.94c-1.53 0-2.43-1.55-1.7-2.79L10.3 2.98A1.96 1.96 0 0 1 12 2zm-1 5h2v7h-2V7zm0 9h2v2h-2v-2z"/>';

      const text = document.createElement('p');
      text.textContent = String(message ?? '');
      text.style.margin = '8px 0 14px';
      text.style.lineHeight = '1.5';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = 'OK';
      btn.style.background = 'rgba(255,255,255,0.15)';
      btn.style.color = 'white';
      btn.style.padding = '8px 16px';
      btn.style.borderRadius = '9999px';
      btn.style.border = '1px solid rgba(255,255,255,0.35)';
      btn.style.cursor = 'pointer';

      btn.addEventListener('click', () => overlay.remove());
      overlay.addEventListener('click', (e) => { if (e.target === overlay) overlay.remove(); });
      window.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { overlay.remove(); window.removeEventListener('keydown', esc); } });

      modal.appendChild(icon);
      modal.appendChild(text);
      modal.appendChild(btn);
      overlay.appendChild(modal);
      document.body.appendChild(overlay);
    } catch (e) {
      originalAlert(message);
    }
  };
})();
